import React, { FC } from 'react';
import { ProductsListPageSkeleton } from '../placementProduct/placementProductSkeleton';

export const BulkProductsListPageSkeleton: FC = () => <ProductsListPageSkeleton titleWidth='240px' actionWidth='' />;
